<div class="_gst_template">
  <h3 matDialogTitle class="dialog-title">GST Information<button [mat-dialog-close]="gstInformation" color="primary"
    mat-icon-button>
    <mat-icon>close</mat-icon>
  </button></h3>
  <p class="gstBtn">Use GTSIN for this booking</p>
  <mat-card class="text-center">
    <form [formGroup]="gstInformation">
      <mat-form-field appearance="outline" color="primary" class="col-md-12" floatLabel="always">
        <mat-label>GST Customer Number</mat-label>
        <input matInput placeholder="GST Customer Number" [formControl]="gst_customer_number" maxlength="15" minlength="15">
        <mat-error *ngIf="gst_customer_number.hasError('required')"><strong>GST Customer Number</strong> is required.
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="primary" class="col-md-12" floatLabel="always">
        <mat-label>Company Name</mat-label>
        <input matInput placeholder="Company Name" [formControl]="gst_company_name">
        <mat-error *ngIf="gst_company_name.hasError('required')"><strong>Company Name</strong> is required.
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="primary" class="col-md-12" floatLabel="always">
        <mat-label>Customer Email Address</mat-label>
        <input matInput placeholder="Customer Email Address" [formControl]="gst_email_id" appLowercaseInput>
        <mat-error *ngIf="gst_email_id.hasError('required')"><strong>Customer Email Address</strong> is required.
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="primary" class="col-md-12" floatLabel="always">
        <mat-label>Customer Address</mat-label>
        <input matInput placeholder="Customer Address" [formControl]="customerAddress">
        <mat-error *ngIf="customerAddress.hasError('required')"><strong>Customer Email Address</strong> is required.
        </mat-error>
      </mat-form-field>
      <button mat-button class="submitBtn"  (click)="submit()">Submit</button>
    </form>
    <!-- {{gstList | json}} -->
  </mat-card>
</div>
